import React, { useEffect, useState } from "react";
import { useFetchCompletedProjectsQuery } from "../../../../services/baseQuery";
import { OvalLoader } from "../../../Common/Loaders";
import { convertTimestampToDate, projectStatus } from "../../../../utils";
import { useNavigate } from "react-router-dom";

const tableData = [
  {
    id: "1",
    serialNo: 1,
    title: "Kaam karna hai",
    budget: "bht sara",
    proposalDeadline: "2/2/23",
    projectDeadline: "2/2/2",
    type: "Posted",
    merchFinalized: "ABC Construction",
    postedBy: "starbucks",
  },
];

export default function CompleteProjectTable() {
  const navigate = useNavigate();
  const {
    isLoading,
    isError,
    data: completedProjects,
    error,
    isFetching,
  } = useFetchCompletedProjectsQuery();

  const handleViewProject = (projectId) => {
    navigate(`/project-details/${projectId}/${projectStatus.COMPLETE}`);
  };

  return (
    <div
      className="verificationTableContainer"
      style={{ position: "relative", height: "74.2%" }}
    >
      <div
        className="verificationTableRow"
        style={{
          position: "sticky",
          top: 0,
          backgroundColor: "white",
          zIndex: 1,
        }}
      >
        <div
          style={{ width: "10%", height: "100%" }}
          className="eachColumn eachTableHead"
        >
          Sr. No.
        </div>
        <div
          style={{ width: "18%", height: "100%" }}
          className="eachColumn eachTableHead"
        >
          Title
        </div>
        <div
          style={{ width: "12%", height: "100%" }}
          className="eachColumn eachTableHead"
        >
          Price Finalized
        </div>
        <div
          style={{ width: "18%", height: "100%" }}
          className="eachColumn eachTableHead"
        >
          Posted By
        </div>
        <div
          style={{ width: "18%", height: "100%" }}
          className="eachColumn eachTableHead"
        >
          Merchant Finalized
        </div>
        <div
          style={{ width: "12%", height: "100%" }}
          className="eachColumn eachTableHead"
        >
          Project Completedon
        </div>
        {/* <div
      style={{ width: "15%", height: "100%" }}
      className="eachColumn eachTableHead"
    >
      Type
    </div> */}
        <div
          style={{ width: "12%", height: "100%" }}
          className="eachColumn eachTableHead"
        >
          View Details
        </div>
      </div>
      {isLoading ? (
        <OvalLoader visible={true} color="#3366CC" />
      ) : completedProjects?.length < 1 ? (
        <div>no posted projects</div>
      ) : (
        completedProjects?.map((item, i) => (
          <div
            className="verificationTableRow"
            key={i}
            style={{
              backgroundColor: i % 2 === 0 ? "#6b5acd0e" : "#6b5acd1d",
            }}
          >
            <div
              style={{ width: "10%", height: "100%" }}
              className="eachColumn eachTableBody"
            >
              {i + 1}
            </div>
            <div
              style={{
                width: "18%",
                height: "100%",
                textDecoration: "underline",
                whiteSpace: "nowrap",
              }}
              className="eachColumn eachTableBody"
            >
              {item.title.slice(0, 25)}
            </div>
            <div
              style={{ width: "12%", height: "100%" }}
              className="eachColumn eachTableBody"
            >
              {item.priceFinalized} SAR
            </div>
            <div
              style={{ width: "18%", height: "100%" }}
              className="eachColumn eachTableBody"
            >
              {item.uploadedByData.displayName}
            </div>
            <div
              style={{ width: "18%", height: "100%" }}
              className="eachColumn eachTableBody"
            >
              {item.merchFinalizedData.displayName}
            </div>
            <div
              style={{ width: "12%", height: "100%" }}
              className="eachColumn eachTableBody"
            >
              {convertTimestampToDate(item?.completedOn)}
            </div>
            {/* <div
              style={{ width: "15%", height: "100%" }}
              className="eachColumn eachTableBody"
            >
              {item.type}
            </div> */}
            <div
              style={{
                width: "12%",
                height: "100%",
                textDecoration: "underline",
                color: "#3366CC",
                cursor: "pointer",
              }}
              className="eachColumn eachTableBody"
              onClick={() => handleViewProject(item.id)}
            >
              View Project
            </div>
          </div>
        ))
      )}
    </div>
  );
}
